import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";

import { faCoffee } from "@fortawesome/free-solid-svg-icons/faCoffee";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons/faCommentDots";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons/faUserPlus";
import { faBook } from "@fortawesome/free-solid-svg-icons/faBook";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faLongArrowAltUp } from "@fortawesome/free-solid-svg-icons/faLongArrowAltUp";
import { faSort } from "@fortawesome/free-solid-svg-icons/faSort";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons/faLongArrowAltDown";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { faAnchor } from "@fortawesome/free-solid-svg-icons/faAnchor";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faMinusSquare } from "@fortawesome/free-solid-svg-icons/faMinusSquare";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons/faPlusSquare";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons/faCloudUploadAlt";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { faObjectGroup } from "@fortawesome/free-solid-svg-icons/faObjectGroup";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faCompressArrowsAlt } from "@fortawesome/free-solid-svg-icons/faCompressArrowsAlt";
import { faFileImport } from "@fortawesome/free-solid-svg-icons/faFileImport";
import { faDatabase } from "@fortawesome/free-solid-svg-icons/faDatabase";
import { faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpenText";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons/faNewspaper";
import { faSadCry } from "@fortawesome/free-solid-svg-icons/faSadCry";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faSync } from "@fortawesome/free-solid-svg-icons/faSync";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default function initFonts() {
  library.add(
    faCoffee,
    faHome,
    faUser,
    faCommentDots,
    faBell,
    faSearch,
    faUserPlus,
    faBook,
    faTimes,
    faLongArrowAltUp,
    faLongArrowAltDown,
    faSort,
    faSignOutAlt,
    faAnchor,
    faCheck,
    faPlusSquare,
    faMinusSquare,
    faCloudUploadAlt,
    faPlusCircle,
    faObjectGroup,
    faTrashAlt,
    faPencilAlt,
    faCopy,
    faPlus,
    faCompressArrowsAlt,
    faFileImport,
    faDatabase,
    faEnvelopeOpenText,
    faNewspaper,
    faSadCry,
    faArrowLeft,
    faSync
  );
  Vue.component("FontAwesomeIcon", FontAwesomeIcon);
}
